// UI-5: the Add task / Edit task modal. TaskForm renders the v2 Modal itself (header band, the
// form, the footer with its buttons), so this only passes App's state through. The old portal,
// close button and the meeting-link block (behind a createMeeting prop App never passed) are gone.
import React from "react";
import TaskForm from "../TaskForm";

function TaskModal({ show, onClose, title, priority, editingId, createMeeting, setCreateMeeting, ...rest }) {
  if (!show) return null;
  return (
    <TaskForm
      {...rest}
      open
      title={title || ''}
      priority={priority || 'Medium'}
      editingId={editingId || null}
      onCancel={onClose}
    />
  );
}

export default TaskModal;
